import store from "../store";

export default function (context:any) {
    const eventID = context.to.params.id;
    store.dispatch("API_CALL", { method: "get", url: "/events/" + eventID }).then((res) => {
        store.commit("setUserInfo", { user: { firstName: "Test", lastName: "Preview"}});
        store.commit("setEvent", res.data);
        return context.next();
    })
}